import moment from 'moment';

import { isCancelledPrebooking } from './setBookingDate';

// Maps a prebooking returned by GET /prebooking?userType=Interpreter to a react-big-calendar event.
// Recently cancelled bookings (cancelledAt set) stay on the calendar but are flagged so the tile can mark them.
export const toPrebookingEvent = (booking, now = moment()) => ({
  start: moment(new Date(booking.interpretationDate)).toDate(),
  end: moment(new Date(booking.interpretationDate + (booking.durationEstimated * 1000))).toDate(),
  title: booking.interpretedLanguage.name,
  prebook: booking,
  type: moment(booking.interpretationDate).isAfter(now) ? 'prebook' : 'previous_prebooking',
  cancelled: isCancelledPrebooking(booking),
});

export const getEventClassName = (event) => (
  `${event.type}${event.previous ? ' previous' : ''}${event.cancelled ? ' cancelled' : ''}`
);
